import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { isRole } from 'utils/utils';
import { pluck, sum } from 'ramda';
import { ReactComponent as RiverLogo } from '../../assets/images/image_river_logo.svg';
import { paths } from '../../routes';
import { AuthUser } from '../../types/types';
import Icon, { IconSprite } from '../Icon/Icon';
import Image from '../Image/Image';

type NavbarProps = {
  user: AuthUser | null;
  logout: () => void;
};

function Navbar({ user, logout }: NavbarProps) {
  // const msgsCount = [ { patient: { id: '', name: 'James Kwabla' },messageCount: 3,lastMessageContent: 'I am fine and you'}];

  return (
    <header
      className="bg-white shadow-sm shadow-[#e9ecef] flex justify-between
     sticky top-0 inset-x-0 z-30 flex-none min-h-[80px] px-6 tablet:px-10 items-center"
    >
      <Link to="/" className="block">
        <RiverLogo className="w-20 tablet:w-16" />
      </Link>

      <nav>
        <ul className="flex flex-row space-x-4 tablet:space-x-8 items-center text-[15px]">
          {/* {msgsCount && user?.roles && isRole(user.roles, 'CARE-HEALTH-GUIDE') && (
            <li className="group/messages relative " tabIndex={-1}>
              <button
                type="button"
                className="bg-gray-50 rounded-full w-[36px] h-[36px] justify-center items-center flex relative"
              >
                <span className="sr-only">View messages</span>
                <IconSprite
                  id="icon-envelope"
                  className="w-[20px] h-[20px] text-gray-400 stroke-gray-400"
                />

                {msgsCount.length > 0 && (
                  <span
                    className="absolute top-[-5px] -right-[5px] bg-[#FF6045] h-[18px] w-[18px] rounded-full items-center justify-center
                  text-[11px] text-center text-white ml-2 inline-flex font-medium"
                  >
                    {sum(pluck('messageCount', msgsCount))}
                  </span>
                )}
              </button>

              <div
                className="invisible opacity-0 absolute top-full w-[250px] tablet:w-[350px] transform transition-all 
                duration-300 right-0 group-focus-within/messages:visible group-focus-within/messages:opacity-100"
              >
                <ul
                  className="flex flex-col max-h-[370px] mt-2 right-0 rounded-lg 
                  shadow-[0_0px_15px_0px_rgba(0,0,0,0.08)] text-[15px] bg-white border-[0.5px] border-stone-300
                 ring-[#e9ecef] ring-opacity-5 focus:outline-none overflow-auto"
                >
                  <li
                    className="sticky bg-white top-0 after:content-[''] after:block after:mx-auto after:border-b-[0.5px] 
                    after:border-[#e9ecef] after:pt-[11px]"
                  >
                    <span className="px-5 pt-[11px] block font-medium">
                      {msgsCount.length > 0 ? 'Unread Messages' : 'No Messages'}
                    </span>
                  </li>

                  {msgsCount.map(fndCount => (
                    <li
                      key={fndCount.patient.id}
                      className="flex-1 cursor-pointer hover:bg-black/[0.04] after:content-[''] 
                    after:block after:mx-auto after:border-b-[0.5px] after:border-[#e9ecef] after:pt-[14px]"
                    >
                      <a
                        href="#"
                        // href={getMessageDropURL(fndCount.patient.id, fndCount.lastQuestionnaireId)}
                        className="flex flex-row pl-[15px] pr-[20px] pt-[14px] space-x-3"
                      >
                        <button
                          type="button"
                          className="bg-gray-50 rounded-full w-[35px] h-[35px] justify-center items-center flex shrink-0"
                        >
                          <IconSprite
                            id="icon-envelope"
                            className="w-[19px] h-[19px] text-gray-400 stroke-gray-400"
                          />
                        </button>
                        <div className="overflow-hidden -mt-1">
                          <p className="text-[13px] whitespace-pre text-ellipsis overflow-hidden font-light">
                            <span className="font-medium">
                              {fndCount.messageCount} new messages
                            </span>{' '}
                            from <span className="font-medium">{fndCount.patient.name}</span>
                          </p>
                          <p className="text-[14.7px] whitespace-nowrap overflow-hidden text-ellipsis text-zinc-400">
                            {fndCount.lastMessageContent}
                          </p>
                        </div>
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </li>
          )} */}

          <li className="group/profile relative" tabIndex={-2}>
            <button type="button" className="max-w-xs flex items-center text-[15px]">
              <Image
                className="h-[50px] w-[50px] rounded-full tablet:mr-2"
                src={user?.signedAvatar || 'image_doc_avatar_placeholder.png'}
                alt="user avatar"
                bgColor={user?.avatarPlaceholderColor || ''}
              />
              <span className="hidden tablet:inline-flex font-medium">
                Hi, {user?.firstName || 'Doc'}
              </span>
              <Icon
                id="arrowDown"
                className="ml-[5px] h-[18px] w-[18px] hidden tablet:inline-flex"
              />
            </button>

            <div
              className="invisible absolute top-full min-w-[180px] transform opacity-0 transition-all
                duration-300 group-focus-within/profile:visible group-focus-within/profile:opacity-100 right-0"
            >
              <ul
                className="mt-2 right-0 rounded-md shadow-[0_0px_15px_0px_rgba(0,0,0,0.08)] text-[15px]
                bg-white border-[0.5px] border-[#e9ecef] ring-[#e9ecef] ring-opacity-5 focus:outline-none"
              >
                <li
                  className="px-2 pt-2 text-gray-700 hover:bg-black/[0.04] after:content-[''] 
                    last:after:hidden  after:block after:mx-auto after:border-b-[0.5px] after:border-[#e9ecef] after:pt-2"
                >
                  <NavLink to={paths.PROFILE_URL_PATH} className="block">
                    <Icon
                      id="iconUserProfileMenu"
                      className="w-[15px] inline-flex mr-4 text-[#676767]"
                    />
                    Profile
                  </NavLink>
                </li>
                <li
                  className="px-2 pt-2 text-gray-700 hover:bg-black/[0.04] after:content-['']
                    last:after:invisible after:block after:mx-auto after:border-b-[0.5px] after:border-[#e9ecef] after:pt-2"
                >
                  <NavLink to="/" onClick={logout} className="block">
                    <Icon
                      id="iconUserProfileMenuLogout"
                      className="w-5 inline-flex mr-[13px] text-[#676767]"
                    />
                    Logout
                  </NavLink>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </nav>
    </header>
  );
}

export default Navbar;
